import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

import Routes from './routes';
import { ThemeProvider as AppThemeProvider } from './hooks/useAppTheme';
import muiTheme from './themes/muiTheme';

const App = () => {
  return (
    /* MuiThemeProvider задаёт общий масштаб типографики и мобильные правила
       (см. themes/muiTheme.js). Цветовую тему по-прежнему ведёт AppThemeProvider. */
    <MuiThemeProvider theme={muiTheme}>
      <AppThemeProvider>
        <Routes />
      </AppThemeProvider>
    </MuiThemeProvider>
  );
};

export default App;
